import dayjs from 'dayjs'

export interface MonthlyReport {
	id: number
	from: string
	totalConsumption: number
	totalBill: number
	heatingConsumption: number
}

const findYearAgoReport = (report: MonthlyReport, allReports: MonthlyReport[]) => {
	const from = dayjs(report.from)
	return allReports.find(
		r => dayjs(r.from).month() === from.month() && dayjs(r.from).year() === from.year() - 1
	)
}

export const getYearAgoChange = (
	field: 'totalConsumption' | 'totalBill',
	report: MonthlyReport,
	allReports: MonthlyReport[]
) => {
	const yearAgoReport = findYearAgoReport(report, allReports)
	if (!yearAgoReport || !yearAgoReport[field]) return null

	return ((report[field] - yearAgoReport[field]) / yearAgoReport[field]) * 100
}

export const groupReportsByYear = (reports: MonthlyReport[]) => {
	const groups = new Map<string, MonthlyReport[]>()
	for (const report of reports) {
		const year = dayjs(report.from).format('YYYY')
		const yearReports = groups.get(year) ?? []
		yearReports.push(report)
		groups.set(year, yearReports)
	}
	for (const yearReports of groups.values()) {
		yearReports.sort((a, b) => dayjs(b.from).valueOf() - dayjs(a.from).valueOf())
	}
	return Array.from(groups.entries()).sort(([a], [b]) => Number(b) - Number(a))
}
